// Bilingual content for Big Boss Snack Bar — Fast food edition
export const content = {
  brand: "Big Boss Snack Bar",
  city: "La Neuveville · Suisse",
  externalLinks: {
    order: "https://order.ojavana.com/store/4ed5a229-967a-439f-ac72-8113417724a4",
    reservation: "https://wearebigboss.wearebookers.com/",
  },
  contactInfo: {
    address: "Chem. des Vergers 20, 2520 La Neuveville, Switzerland",
    addressLines: ["Chem. des Vergers 20", "2520 La Neuveville, Suisse"],
    phone: "+41 32 751 25 20",
    phoneHref: "tel:+41327512520",
    mapEmbed:
      "https://www.google.com/maps?q=Chem.+des+Vergers+20,+2520+La+Neuveville,+Switzerland&output=embed",
    mapLink:
      "https://www.google.com/maps/search/?api=1&query=Chem.+des+Vergers+20%2C+2520+La+Neuveville%2C+Switzerland",
  },

  nav: {
    fr: [
      { label: "Menu", href: "#menu" },
      { label: "Pourquoi nous", href: "#why" },
      { label: "Réserver", href: "#reservation" },
      { label: "Horaires", href: "#hours" },
      { label: "Contact", href: "#contact" },
    ],
    en: [
      { label: "Menu", href: "#menu" },
      { label: "Why us", href: "#why" },
      { label: "Reserve", href: "#reservation" },
      { label: "Hours", href: "#hours" },
      { label: "Contact", href: "#contact" },
    ],
  },

  hero: {
    fr: {
      eyebrow: "La Neuveville · Suisse",
      title: "Big Boss",
      titleAccent: "Snack Bar",
      h1: "Big Boss Snack Bar La Neuveville",
      tagline: "Tacos, Kebabs, Bowls & Sandwichs",
      taglineAccent: "Frais, Rapide et Délicieux",
      sub: "Découvrez le meilleur snack à La Neuveville avec des tacos, kebabs, bowls et sandwichs préparés à la minute. Service rapide, portions généreuses et goût incomparable.",
      cta1: "Commander",
      cta2: "Réserver une table",
    },
    en: {
      eyebrow: "La Neuveville · Switzerland",
      title: "Big Boss",
      titleAccent: "Snack Bar",
      h1: "Big Boss Snack Bar La Neuveville",
      tagline: "Tacos, Kebabs, Bowls & Sandwiches",
      taglineAccent: "Fresh, Fast & Delicious",
      sub: "Enjoy the best fast food in La Neuveville with freshly prepared tacos, kebabs, bowls, and sandwiches. Quick service, generous portions, and unbeatable taste.",
      cta1: "Order Now",
      cta2: "Reserve Table",
    },
  },

  about: {
    fr: {
      eyebrow: "À propos",
      title: "Votre Snack Préféré",
      titleAccent: "à La Neuveville",
      p1: "Chez Big Boss Snack Bar, nous proposons une restauration rapide de qualité, préparée chaque jour avec des ingrédients frais. Tacos gourmands, kebabs savoureux, bowls frais et sandwichs délicieux – chaque plat est réalisé avec soin.",
      p2: "Que ce soit pour un déjeuner rapide, un dîner ou un takeaway, nous sommes votre adresse incontournable à La Neuveville.",
    },
    en: {
      eyebrow: "About",
      title: "Your Favorite Snack Bar",
      titleAccent: "in La Neuveville",
      p1: "At Big Boss Snack Bar, we serve high-quality fast food made fresh every day. From loaded tacos and flavorful kebabs to fresh bowls and tasty sandwiches, every dish is prepared with care using quality ingredients.",
      p2: "Whether you're looking for a quick lunch, dinner with friends, or takeaway, we are your go-to snack bar in La Neuveville.",
    },
  },

  promo: {
    fr: ["Cuisine fraîche", "Service rapide", "Portions généreuses", "100% maison"],
    en: ["Fresh Food", "Fast Service", "Big Portions", "100% homemade"],
  },

  // === MENU DATA ===
  menu: {
    fr: {
      eyebrow: "Le Menu",
      title: "Notre Menu",
      titleAccent: "Frais et Savoureux",
      sub: "Découvrez notre large sélection de tacos, bowls, kebabs, sandwichs et box. Des menus classiques aux options XL avec frites et boisson, il y en a pour toutes les envies. Profitez d'une cuisine rapide, savoureuse et préparée à la commande.",
      cta: "Commander maintenant",
      currency: "CHF",
      categories: [
        {
          id: "tacos",
          icon: "🌮",
          name: "Tacos",
          tagline: "Croustillant, fondant, généreux.",
          items: [
            { name: "Tacos Normal", price: "13.00" },
            { name: "Tacos XL", price: "18.00" },
            {
              name: "Tacos Menu",
              price: "16.00",
              note: "Tacos + frites + boisson 33cl",
            },
            { name: "Tacos Menu XL", price: "21.00" },
          ],
        },
        {
          id: "bowls",
          icon: "🥗",
          name: "Bowls",
          tagline: "Frais, équilibré, rassasiant.",
          items: [
            { name: "Bowl", price: "13.00" },
            { name: "Bowl Menu", price: "16.00" },
            { name: "Bowl 2 Viandes", price: "15.00" },
            { name: "Bowl Menu 2 Viandes", price: "19.00" },
          ],
        },
        {
          id: "galettes",
          icon: "🌯",
          name: "Galettes",
          tagline: "La street food à la suisse.",
          items: [
            {
              name: "Galette Kebab",
              price: "12.00",
              note: "Avec frites + boisson",
            },
            { name: "Mega Galette", price: "18.00" },
            { name: "Galette Falafel", price: "12.00" },
          ],
        },
        {
          id: "sandwiches",
          icon: "🥪",
          name: "Sandwiches",
          tagline: "Le classique, version Boss.",
          items: [
            { name: "Sandwich", price: "12.00" },
            { name: "Grand Sandwich", price: "15.00" },
            { name: "Sandwich Steak Vigneron", price: "12.00" },
            { name: "Sandwich Köfte", price: "12.00" },
            { name: "Sandwich Thon", price: "7.00" },
            { name: "Sandwich Poulet", price: "7.00" },
          ],
        },
        {
          id: "box",
          icon: "🍟",
          name: "Box",
          tagline: "À partager… ou pas.",
          items: [
            { name: "Box Kebab", price: "13.00" },
            { name: "Box Nuggets", price: "13.00" },
            { name: "Box Tenders", price: "13.00" },
            { name: "Box Kebab Raclette", price: "14.00" },
          ],
        },
        {
          id: "drinks",
          icon: "🥤",
          name: "Boissons",
          tagline: "Pour faire passer le tout.",
          items: [
            { name: "Coca Cola", price: "3.50" },
            { name: "Coca Zero", price: "3.50" },
            { name: "Fanta", price: "3.50" },
            { name: "Sprite", price: "3.50" },
            { name: "Red Bull", price: "4.50" },
            {
              name: "Oasis",
              price: "3.50",
              note: "Tropical · Fraise-Framboise · Pomme-Poire · Pomme-Cassis",
            },
            {
              name: "Ice Tea",
              price: "3.50",
              note: "Citron · Pêche · Wild Berry · Citron Menthe",
            },
            { name: "Ayran", price: "3.50" },
          ],
        },
      ],
    },
    en: {
      eyebrow: "The Menu",
      title: "Our Menu",
      titleAccent: "Fresh & Flavorful",
      sub: "Discover our wide selection of tacos, bowls, kebabs, sandwiches, and snack boxes. From classic tacos to XL menus with fries and drinks, we offer something for every appetite. Enjoy delicious fast food made fresh and served quickly.",
      cta: "Order Now",
      currency: "CHF",
      categories: [
        {
          id: "tacos",
          icon: "🌮",
          name: "Tacos",
          tagline: "Crispy, melty, loaded.",
          items: [
            { name: "Tacos Normal", price: "13.00" },
            { name: "Tacos XL", price: "18.00" },
            {
              name: "Tacos Menu",
              price: "16.00",
              note: "Tacos + fries + 33cl drink",
            },
            { name: "Tacos Menu XL", price: "21.00" },
          ],
        },
        {
          id: "bowls",
          icon: "🥗",
          name: "Bowls",
          tagline: "Fresh, balanced, filling.",
          items: [
            { name: "Bowl", price: "13.00" },
            { name: "Bowl Menu", price: "16.00" },
            { name: "Bowl 2 Meats", price: "15.00" },
            { name: "Bowl Menu 2 Meats", price: "19.00" },
          ],
        },
        {
          id: "galettes",
          icon: "🌯",
          name: "Galettes",
          tagline: "Street food, Swiss style.",
          items: [
            {
              name: "Galette Kebab",
              price: "12.00",
              note: "With fries + drink",
            },
            { name: "Mega Galette", price: "18.00" },
            { name: "Galette Falafel", price: "12.00" },
          ],
        },
        {
          id: "sandwiches",
          icon: "🥪",
          name: "Sandwiches",
          tagline: "The classic, Boss-style.",
          items: [
            { name: "Sandwich", price: "12.00" },
            { name: "Grand Sandwich", price: "15.00" },
            { name: "Steak Vigneron Sandwich", price: "12.00" },
            { name: "Köfte Sandwich", price: "12.00" },
            { name: "Tuna Sandwich", price: "7.00" },
            { name: "Chicken Sandwich", price: "7.00" },
          ],
        },
        {
          id: "box",
          icon: "🍟",
          name: "Box",
          tagline: "Share it… or don't.",
          items: [
            { name: "Kebab Box", price: "13.00" },
            { name: "Nuggets Box", price: "13.00" },
            { name: "Tenders Box", price: "13.00" },
            { name: "Kebab Raclette Box", price: "14.00" },
          ],
        },
        {
          id: "drinks",
          icon: "🥤",
          name: "Drinks",
          tagline: "Wash it down.",
          items: [
            { name: "Coca Cola", price: "3.50" },
            { name: "Coca Zero", price: "3.50" },
            { name: "Fanta", price: "3.50" },
            { name: "Sprite", price: "3.50" },
            { name: "Red Bull", price: "4.50" },
            {
              name: "Oasis",
              price: "3.50",
              note: "Tropical · Strawberry-Raspberry · Apple-Pear · Apple-Blackcurrant",
            },
            {
              name: "Ice Tea",
              price: "3.50",
              note: "Lemon · Peach · Wild Berry · Lemon-Mint",
            },
            { name: "Ayran", price: "3.50" },
          ],
        },
      ],
    },
  },

  why: {
    fr: {
      eyebrow: "Pourquoi nous",
      title: "Pourquoi Choisir",
      titleAccent: "Big Boss Snack Bar",
      sub: "Cinq raisons de revenir, encore et encore.",
      items: [
        {
          icon: "🥬",
          t: "Ingrédients frais chaque jour",
          d: "Sélection quotidienne, qualité non négociable.",
        },
        {
          icon: "⚡",
          t: "Service rapide et efficace",
          d: "Sur place ou à emporter, en quelques minutes.",
        },
        {
          icon: "🥙",
          t: "Portions généreuses",
          d: "Pensées pour vraiment rassasier, pas pour la déco.",
        },
        {
          icon: "💛",
          t: "Prix abordables",
          d: "Le bon goût, sans casser le porte-monnaie.",
        },
        {
          icon: "📍",
          t: "Snack apprécié à La Neuveville",
          d: "Le rendez-vous des locaux depuis toujours.",
        },
      ],
    },
    en: {
      eyebrow: "Why us",
      title: "Why Choose",
      titleAccent: "Big Boss Snack Bar",
      sub: "Five reasons to come back, again and again.",
      items: [
        {
          icon: "🥬",
          t: "Fresh ingredients daily",
          d: "Picked daily, quality is non-negotiable.",
        },
        {
          icon: "⚡",
          t: "Fast and friendly service",
          d: "Eat in or take away — ready in minutes.",
        },
        {
          icon: "🥙",
          t: "Generous portions",
          d: "Built to actually fill you up, not for show.",
        },
        {
          icon: "💛",
          t: "Affordable prices",
          d: "Great taste without breaking the bank.",
        },
        {
          icon: "📍",
          t: "Local favorite in La Neuveville",
          d: "The locals' go-to spot, always.",
        },
      ],
    },
  },

  order: {
    fr: {
      eyebrow: "Commander",
      title: "Commander en Ligne",
      titleAccent: "à La Neuveville",
      sub: "Envie de tacos ou de kebabs ? Commandez en ligne en quelques clics et profitez de vos plats préférés où que vous soyez. Préparation rapide et commande facile.",
      cta: "Commander",
      stat1: "5 min",
      stat1Label: "Pour commander",
      stat2: "20 min",
      stat2Label: "Préparation",
      stat3: "100%",
      stat3Label: "Frais",
    },
    en: {
      eyebrow: "Order",
      title: "Order Online",
      titleAccent: "in La Neuveville",
      sub: "Craving tacos or kebabs? Order online in just a few clicks and enjoy your favorite meals at home or on the go. Fast preparation and easy ordering.",
      cta: "Order Now",
      stat1: "5 min",
      stat1Label: "To order",
      stat2: "20 min",
      stat2Label: "Prep time",
      stat3: "100%",
      stat3Label: "Fresh",
    },
  },

  reserve: {
    fr: {
      eyebrow: "Réservation",
      title: "Réservez",
      titleAccent: "Votre Table",
      sub: "Réservez votre table chez Big Boss Snack Bar et profitez d'un moment agréable entre amis ou en famille à La Neuveville.",
      cta: "Réserver une table",
    },
    en: {
      eyebrow: "Reservation",
      title: "Reserve",
      titleAccent: "Your Table",
      sub: "Book your table at Big Boss Snack Bar and enjoy a relaxed dining experience with friends and family in La Neuveville.",
      cta: "Reserve Table",
    },
  },

  hours: {
    fr: {
      eyebrow: "Horaires",
      title: "Horaires d'Ouverture",
      lines: [
        { d: "Lundi à Dimanche", h: "11h00 – 14h00" },
        { d: "Lundi à Dimanche", h: "17h00 – 22h30" },
      ],
    },
    en: {
      eyebrow: "Hours",
      title: "Opening Hours",
      lines: [
        { d: "Monday to Sunday", h: "11:00 – 14:00" },
        { d: "Monday to Sunday", h: "17:00 – 22:30" },
      ],
    },
  },

  contact: {
    fr: {
      eyebrow: "Contact",
      title: "Nous Trouver",
      titleAccent: "à La Neuveville",
      sub: "Big Boss Snack Bar est situé au Chem. des Vergers 20, 2520 La Neuveville, Suisse. Facile d'accès pour emporter ou sur place. Appelez-nous au +41 32 751 25 20.",
      addressLabel: "Adresse",
      phoneLabel: "Téléphone",
      directions: "Itinéraire",
    },
    en: {
      eyebrow: "Contact",
      title: "Visit Us",
      titleAccent: "in La Neuveville",
      sub: "Big Boss Snack Bar is located at Chem. des Vergers 20, 2520 La Neuveville, Switzerland. Easily accessible for takeaway or dine-in. Call us at +41 32 751 25 20.",
      addressLabel: "Address",
      phoneLabel: "Phone",
      directions: "Get directions",
    },
  },

  testimonials: {
    fr: {
      eyebrow: "Ils kiffent",
      items: [
        { q: "Les meilleurs tacos du coin, sans hésiter.", n: "Léa M.", c: "Bienne" },
        { q: "Super rapide et trop bon. J'y retourne ce soir.", n: "Julien R.", c: "La Neuveville" },
        { q: "Portions énormes, prix juste, goût au top.", n: "Sara D.", c: "Neuchâtel" },
        { q: "La galette kebab, c'est juste une dinguerie.", n: "Yanis K.", c: "Bienne" },
      ],
    },
    en: {
      eyebrow: "They love it",
      items: [
        { q: "Best tacos in town, hands down.", n: "Léa M.", c: "Biel/Bienne" },
        { q: "Super fast, super good. Going back tonight.", n: "Julien R.", c: "La Neuveville" },
        { q: "Massive portions, fair price, top flavour.", n: "Sara D.", c: "Neuchâtel" },
        { q: "The galette kebab is straight-up insane.", n: "Yanis K.", c: "Biel" },
      ],
    },
  },

  footer: {
    fr: {
      slogan: "Mangez grand. Mangez Boss.",
      rights: "Tous droits réservés.",
      followUs: "Suivez-nous",
      quickLinks: "Liens rapides",
    },
    en: {
      slogan: "Eat Big. Eat Boss.",
      rights: "All rights reserved.",
      followUs: "Follow us",
      quickLinks: "Quick links",
    },
  },
};
